import { defineStore } from 'pinia';
export const canvasStore = defineStore('canvas', {
  state() {
    return {
      selectPixelList: [],
      activeColorId: 0,
      selectColorList: [],
      selectColorId: 0,
      page: 0,
      colorSize:32,
      changeColorSize:32
    };
  },
  actions: {
    getColorWidth () {
      const mistake =
        window.screen.width >= 375 ? 82 : window.screen.width > 300 ? 78 : 70;
      this.colorSize = Math.floor((window.screen.width * 0.9 - mistake) / 8);
      const mistake2 =
      window.screen.width >= 375 ? 104 : window.screen.width > 300 ? 90 : 82;
      this.changeColorSize = Math.floor((window.screen.width - mistake2) / 8);
      
    },
    changePage(page) {
      this.page = page;
      this.selectPixelList = [];
      this.selectColorList = [];
    },
    selectColorItem(index) {
      if (this.selectColorList[index] == this.activeColorId) {
        this.selectColorList.splice(index, 1);
      } else {
        this.selectColorList = [
          ...this.selectColorList.slice(0, index),
          this.activeColorId,
          ...this.selectColorList.slice(index + 1),
        ];
      }
    },
    clearColor() {
      this.selectColorList = [];
    },
    selectColor(colorId) {
      if (this.activeColorId == colorId) {
        return;
      }

      // if (colorId == 0 ) {
      //   return;
      // }
      this.selectColorId = colorId;
      this.activeColorId = colorId;
      // if (type != 'nft') {
      //   this.selectColorList.push(colorId);
      // }
    },
    pixelExists(params) {
      const index = this.selectPixelList.findIndex(
        (pixel) => pixel.newPixel.boxId === params.newPixel.boxId
      );
      if (index < 0) {
        this.addSelectPixel(params);
        return true;
      }
      if (this.selectPixelList[index].colorId == this.activeColorId) {
        this.removeSelectPixel(params);
        return false;
      } else {
        this.selectPixel(params);
        return true;
      }
    },
    addSelectPixel(params) {
      this.selectPixelList.push(params);
      const arr = this.selectPixelList.filter(
        (pixel) => pixel.colorId === params.colorId
      );

      if (arr.length == 1) {
        this.selectColorList.push(params.colorId);
      }
    },
    removeSelectPixel(params) {
      const index = this.selectPixelList.findIndex(
        (pixel) => pixel.newPixel.boxId === params.newPixel.boxId
      );

      if (index >= 0) {
        this.selectPixelList = [
          ...this.selectPixelList.slice(0, index),
          ...this.selectPixelList.slice(index + 1),
        ];
      }
      const arr = this.selectPixelList.filter(
        (pixel) => pixel.colorId === params.colorId
      );
      if (arr.length == 0) {
        const colorIndex = this.selectColorList.findIndex(
          (color) => color == params.colorId
        );
        this.selectColorList = this.selectColorList.splice(colorIndex, 1);
      }
    },
    selectPixel(params) {
      const index = this.selectPixelList.findIndex(
        (pixel) => pixel.newPixel.boxId === params.newPixel.boxId
      );
      this.selectPixelList[index].colorId = this.activeColorId;
      const arr = this.selectPixelList.filter(
        (pixel) => pixel.colorId === params.colorId
      );
      if (arr.length == 0) {
        const colorIndex = this.selectColorList.findIndex(
          (color) => color == params.colorId
        );
        this.selectColorList = this.selectColorList.splice(colorIndex, 1);
      }
    },
  },
});
